export default "__VITE_ASSET__DtfcdBUm__"